import React, {useState} from "react";
import './squadflix-device-linker.css';
import '../../app/squadflix-tv-mode/components/device-linking/device-linking.css'
import logo from "../../../images/logos/squadDiskHR.png";
import {Spinner} from "../../shared";
import {cn} from "../../../utils/utils";
import {useSelector} from "react-redux";
import users from "../../users";
import {useNavigate} from "react-router-dom";
import {DEVICE_LOCATIONS, DEVICE_TYPES} from "../../../utils/devices-constants";
import {SquadflixLinkingApi} from "../../../apis/squadflix-linking-api/squadflix-linking-api";

const SquadflixDeviceLinker = () => {
    const [code, setCode] = useState(Array(8).fill(''));
    const [loadingCode, setLoadingCode] = useState(false);
    const [deviceId, setDeviceId] = useState(null);
    const queryParams = new URLSearchParams(window.location.search);
    const prefillCode = queryParams.get('code');
    const darkTheme = useSelector(users.selectors.isDarkMode);
    const navigate = useNavigate();

    const [deviceName, setDeviceName] = useState('');
    const [deviceType, setDeviceType] = useState("tv");
    const [deviceLocation, setDeviceLocation] = useState("living_room");


    React.useEffect(() => {
        if (prefillCode && prefillCode.length === 8) {
            setCode(prefillCode.toUpperCase().split(''));
            setLoadingCode(true);
        }
    }, [prefillCode]);

    const getInputs = () => {
        const inputs = [];
        for (let i = 0; i < 8; i++) {
            inputs.push(
                <input className="squadflix-device-linker__input-code" maxLength={1} value={code[i]}
                       id={`squadflix-code-input-${i}`}
                       autoFocus={i === 0}
                       disabled={loadingCode || deviceId}
                       onChange={e => {
                           setCode(prev => {
                               const newCode = [...prev];
                               newCode[i] = e.target.value.slice(0, 1).toUpperCase();
                               return newCode;
                           });
                           if (e.target.value && i < 7) {
                               const nextInput = document.getElementById(`squadflix-code-input-${i + 1}`);
                               if (nextInput) {
                                   nextInput.focus();
                               }
                           } else if (e.target.value && i == 7) {
                               e.target.blur();
                               setLoadingCode(true);
                           }
                       }}/>
            );
            if (i === 3) {
                inputs.push(<span className="squadflix-device-linker__input-separator">-</span>);
            }
        }
        return inputs;
    }

    React.useEffect(() => {
        if (!loadingCode) return;
        if (code.some(c => c == '')) {
            setLoadingCode(false);
            return;
        }
        const enteredCode = code.join('');
        SquadflixLinkingApi.linkDevice({code: enteredCode}).then(response => {
            setLoadingCode(false);
            if (response?.success) {
                setDeviceId(response.deviceId);
            } else {
                alert("Código inválido o expirado. Inténtalo de nuevo.");
                setCode(Array(8).fill(''));
            }
        }).catch(error => {
            setLoadingCode(false);
            console.error("Error linking device:", error);
            alert("Error al enlazar el dispositivo. Inténtalo de nuevo.");
            setCode(Array(8).fill(''));
        });
    }, [code, loadingCode]);

    return (
        <div className="squadflix-device-linker">
            <div className="device-linking__img" style={{
                paddingTop: '1.3rem',
                paddingBottom: '3rem'
            }}>
                <div className="device-linking__img-container">
                    <img width={600} src={logo} alt="Squadflix Logo" className="device-linking-logo"/>
                    <span className="device-linking__img-container-label">SquadFlix TV</span>
                </div>
            </div>
            <div className="squadflix-device-linker__header">
                <h2 className="squadflix-device-linker__title">Enlazar dispositivo</h2>
                <p className="squadflix-device-linker__subtitle">
                    Introduce el código que aparece en tu dispositivo.
                </p>
            </div>
            <div className="squadflix-device-linker__code-section">
                {getInputs()}
            </div>
            {loadingCode && <div className="d-flex flex-column align-items-center justify-content-center text-center">
                <Spinner className="spinner-sm mt-3"/>
            </div>}
            {deviceId &&
                <div className="squadflix-device-linker__success-section">
                    <h3 className="squadflix-device-linker__success-title">Configura tu nuevo dispositivo</h3>
                    <div
                        className={cn("form-floating col-12 mt-3", darkTheme ? "cap17driveSearcher__input__dark" : "cap17driveSearcher__input")}>
                        <input type="text"
                               autoFocus={true}
                               className={cn("form-control col-12")}
                               id="deviceLinkerName" value={deviceName}
                               placeholder="Nombre del dispositivo"
                               onChange={e => setDeviceName(e.target.value)}/>
                        <label htmlFor="searchInput">Nombre del dispositivo</label>
                    </div>
                    <div className="d-flex flex-row gap-3 mt-3">
                        <div
                            className={cn("form-floating w-100", darkTheme ? "cap17driveSearcher__input__dark" : "cap17driveSearcher__input")}>
                            <select
                                className="form-control"
                                value={deviceType}
                                onChange={e => setDeviceType(e.target.value)}>
                                {DEVICE_TYPES.map(type => (
                                    <option key={type.id} value={type.id}>{type.name}</option>
                                ))}
                            </select>
                            <label htmlFor="searchInput">Tipo de dispositivo</label>
                        </div>
                        <div
                            className={cn("form-floating w-100", darkTheme ? "cap17driveSearcher__input__dark" : "cap17driveSearcher__input")}>
                            <select
                                className="form-control"
                                value={deviceLocation || ''}
                                onChange={e => setDeviceLocation(e.target.value)}>
                                {DEVICE_LOCATIONS.map(location => (
                                    <option key={location.id} value={location.id}>{location.name}</option>
                                ))}
                            </select>
                            <label htmlFor="searchInput">Donde está?</label>
                        </div>
                    </div>
                    <button className="btn btn-light w-100 mt-4"
                            disabled={!deviceName}
                            onClick={() => {
                                SquadflixLinkingApi.confirmLinking({
                                    id: deviceId,
                                    name: deviceName,
                                    type: deviceType,
                                    location: deviceLocation
                                }).then(response => {
                                    if (response?.success) {
                                        alert("Dispositivo enlazado y configurado con éxito.");
                                        navigate('/squadflix/devices');
                                    } else {
                                        alert("Error al actualizar la información del dispositivo. Inténtalo de nuevo.");
                                    }
                                }).catch(error => {
                                    console.error("Error updating device info:", error);
                                    alert("Error al actualizar la información del dispositivo. Inténtalo de nuevo.");
                                });
                            }}>
                        Guardar configuración
                    </button>
                </div>}
        </div>);
}

export default SquadflixDeviceLinker;
